module.exports = __webpack_public_path__ + "img/cmapr.994ac799.webp";